// Ícones SVG inline compartilhados — mesmo vocabulário visual do FolderIcon
// (stroke currentColor, strokeWidth ~2, fill none, cantos arredondados).
import { useEffect, useState } from "react";

type IconProps = { size?: number; style?: React.CSSProperties };

const base = (size: number, style?: React.CSSProperties) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  style: { flexShrink: 0, verticalAlign: "-2px", ...style },
});

export function WhatsAppIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
      <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
    </svg>
  );
}

export function InstagramIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <rect x="4" y="4" width="16" height="16" rx="4" />
      <circle cx="12" cy="12" r="3" />
      <line x1="16.5" y1="7.5" x2="16.5" y2="7.51" />
    </svg>
  );
}

export function MessengerIcon({ size = 14, style }: IconProps) {
  // Balão do Messenger com o "raio" característico, no mesmo traço dos demais.
  return (
    <svg {...base(size, style)}>
      <path d="M12 4c-4.4 0-8 3.3-8 7.4 0 2.3 1.2 4.4 3 5.8V20l2.7-1.5c.7.2 1.5.3 2.3.3 4.4 0 8-3.3 8-7.4S16.4 4 12 4z" />
      <path d="m8.5 13.5 2.6-2.8 2.1 2 2.3-2.4" />
    </svg>
  );
}

export function AlertTriangleIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

export function ClockIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

export function XIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export function PhoneIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

export function BookOpenIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  );
}

export function CheckIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function CameraIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

export function MessageIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

export function TagIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M20.59 13.41 12 22l-8.59-8.59A2 2 0 0 1 3 12V4a1 1 0 0 1 1-1h8a2 2 0 0 1 1.41.59l6.18 6.18a2 2 0 0 1 0 2.64z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  );
}

export function CartIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  );
}

export function UsersIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function TransferIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <polyline points="17 1 21 5 17 9" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <polyline points="7 23 3 19 7 15" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  );
}

export function MicIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <line x1="12" y1="19" x2="12" y2="23" />
    </svg>
  );
}

export function PrinterIcon({ size = 14, style }: IconProps) {
  return (
    <svg {...base(size, style)}>
      <polyline points="6 9 6 2 18 2 18 9" />
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
      <rect x="6" y="14" width="12" height="8" />
    </svg>
  );
}

// Feedback de salvar: aparece quando `show` vira true e some sozinho após 2.5s.
export function SavedNote({ show }: { show: boolean }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2500);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 12,
        color: "var(--ok)",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.3s",
      }}
    >
      <CheckIcon size={13} /> Salvo
    </span>
  );
}
